import React, { useEffect, useState } from 'react';
import { ButtonIcon, Col, Icon, Row } from '@cubeyou-team/hx-react-components';
import { EntityInlineSearch, QueryRow } from '../index';
import QueryEntityInfos from './QueryEntityInfos';
import {
  StyledQueryEntityActions,
  StyledQueryEntityContent,
  StyledQueryEntityDrag,
} from './StyledQueryEntity';

const QueryEntityContent = ({
  queryEntity,
  entityInfos,
  parentGroupId,
  index,
  onDeleteEntityRequest,
  onUpdateEntityRequest,
  onEntityDragToggle,
  onRequireMissingItemRequest,
  canDeleteRow = true,
}) => {
  const [isEditing, SetIsEditing] = useState(false);
  const [isDragging, SetIsDragging] = useState(false);

  const hasNoInfos = entityInfos === undefined;

  useEffect(() => {
    if (entityInfos !== undefined) {
      SetIsEditing(false);
    }
  }, [entityInfos]);

  return (
    <React.Fragment>
      <QueryRow
        draggable={!isEditing}
        isDragging={isDragging}
        onDragStart={(e) => {
          SetIsDragging(true);
          onEntityDragToggle(true);
          e.dataTransfer.setData('itemId', e.target.dataset.itemId);
          e.dataTransfer.setData('entityIndex', index);
          e.dataTransfer.setData('parentId', e.target.dataset.parentId);
        }}
        onDragEnd={(e) => {
          SetIsDragging(false);
          onEntityDragToggle(false);
        }}
        data-item-id={queryEntity.id}
        data-parent-id={parentGroupId}
      >
        <StyledQueryEntityDrag isDragging={isDragging}>
          <Icon icon="drag" size="small" variant="dark_lighter" />
        </StyledQueryEntityDrag>
        <StyledQueryEntityContent>
          {isEditing || hasNoInfos ? (
            <EntityInlineSearch
              currentEntityLabel={entityInfos ? entityInfos.name : ''} // entityInfos.name => entityInfos.label when api updates
              index={index}
              onClickOutsideSearch={() => {
                // Dispatching here re-renders mid-click (capture phase) and swallows clicks elsewhere, e.g. radios.
                if (hasNoInfos && canDeleteRow) {
                  onDeleteEntityRequest(parentGroupId, index);
                }
                SetIsEditing(false);
              }}
              onEntityUpdate={(infos) => {
                onUpdateEntityRequest(parentGroupId, infos, index);
                SetIsEditing(false);
              }}
              onRequireMissingItemRequest={onRequireMissingItemRequest}
            />
          ) : (
            <QueryEntityInfos
              queryEntity={queryEntity}
              infos={entityInfos}
              isDragging={isDragging}
            />
          )}
        </StyledQueryEntityContent>
        <StyledQueryEntityActions>
          <Row>
            {!isEditing && (
              <Col span="auto">
                <ButtonIcon
                  icon="edit"
                  size="small"
                  type="button"
                  variant="dark_lighter"
                  onClick={(e) => {
                    e.preventDefault();
                    SetIsEditing(true);
                    e.stopPropagation();
                  }}
                />
              </Col>
            )}

            {canDeleteRow && (
              <Col span="auto">
                <ButtonIcon
                  icon="delete"
                  size="small"
                  type="button"
                  variant="dark_lighter"
                  onClick={(e) => {
                    e.preventDefault();
                    onDeleteEntityRequest(parentGroupId, index);
                    e.stopPropagation();
                  }}
                />
              </Col>
            )}
          </Row>
        </StyledQueryEntityActions>
      </QueryRow>
    </React.Fragment>
  );
};

export default QueryEntityContent;
